export default __webpack_public_path__ + "static/media/machining3.d05628a3.jpg";